import { Helmet } from 'react-helmet-async'

export default function MetaTags({
  title = 'Trine Rosendal - Certificeret hypnoterapeut i Holstebro',
  description = 'Jeg er certificeret hypnoterapeut i Holstebro og har gennem de sidste 12 år arbejdet med både børn, unge og voksne og kan også hjælpe dig som hypnoterapeut.',
  image = 'https://assets.auxodev.dk/assets/0c569b3d-b522-4d44-8ece-350bff7b17df/cat-1005-1-scaled.jpg',
  canonicalUrl,
}) {
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      {image && <meta property="og:image" content={image} />}
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      {image && <meta name="twitter:image" content={image} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </Helmet>
  )
}
